module.exports = __webpack_public_path__ + "img/OTO Finance.a6949431.png";